module.exports = {
  PERSON: { api: 'PERSON', human: 'natürliche Person', versichererAbrechnung: 'Privat', euSanctions: 'person' },
  FIRMA: { api: 'FIRMA', human: 'juristische Person', versichererAbrechnung: 'Firma', euSanctions: 'enterprise' }
}
